import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const ChannelListContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: ${512 * Screen.widthRatio}px;
`;

export default withAnimation(ChannelListContainer);
